import { getApiErrorBody } from "#/src/utils/apiError";

const COPPA_MARKETPLACE_API_ERROR_STR = "user COPPA consent is needed.";
const COPPA_ERROR_CODE = "ERR_COPPA_CONSENT_REQUIRED";

interface CoppaErrorBody {
  code?: string;
  detail?: string | { error?: string };
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}

function isCoppaErrorBody(value: unknown): value is CoppaErrorBody {
  if (!isRecord(value)) {
    return false;
  }

  const { code, detail } = value;
  if (code !== undefined && typeof code !== "string") {
    return false;
  }
  if (detail !== undefined && typeof detail !== "string" && !isRecord(detail)) {
    return false;
  }
  return !isRecord(detail) || detail.error === undefined || typeof detail.error === "string";
}

/** Whether an API failure, from either transport getApiErrorBody reads, is the COPPA-consent-required error. */
export function checkIsCoppaError(error: unknown): boolean {
  // getApiErrorBody types `detail` as a string, but this endpoint can send `{ error: string }` there.
  const errorBody: unknown = getApiErrorBody(error);
  const body = isCoppaErrorBody(errorBody) ? errorBody : undefined;
  const detail = body?.detail;
  const marketplaceApiErrorStr = isRecord(detail) ? detail.error : undefined;
  const coppaErrorCode = body?.code;
  return marketplaceApiErrorStr === COPPA_MARKETPLACE_API_ERROR_STR || coppaErrorCode === COPPA_ERROR_CODE;
}
